import IconStar from '@apollo/icons/large/IconStar.svg';
import { Button } from '@apollo/space-kit/Button';
import classnames from 'classnames';
import React from 'react';

interface Props {
  isFavorite: boolean;
  onClick: React.MouseEventHandler<HTMLElement>;
  ariaLabel?: string;
  'data-testid'?: string;
  theme?: 'light' | 'dark';
  className?: string;
  iconSize?: 'large' | 'small';
}

export const FavoriteButton = ({
  isFavorite,
  onClick,
  ariaLabel,
  className,
  iconSize = 'large',
  ...rest
}: Props) => (
  <Button
    type="button"
    aria-label={`Click to ${isFavorite ? 'unfavorite' : 'favorite'}`}
    className={classnames(
      'min-w-0 fill-current p-0 px-2 duration-100 hover:bg-transparent',
      isFavorite
        ? 'text-yellow hover:text-yellow [&_path]:fill-yellow'
        : 'text-grey-light hover:text-yellow hover:[&_path]:fill-yellow-lighter',
      className,
    )}
    onClick={onClick}
    feel="flat"
    {...rest}
  >
    <IconStar
      className={classnames(
        'flex-none',
        iconSize === 'large' ? 'w-4' : iconSize === 'small' ? 'w-3' : '',
      )}
      cursor="pointer"
    />
  </Button>
);
